import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import historico from '../../../services/Historico';
import sortFunc from '../../../utils/ordernarColunaInt';
import moment from 'moment-timezone';
import RemoteTable from '../RemoteTable/index';
import capitalize from '../../../utils/capitalize';
import './styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faHistory } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import api from '../../../services/API';
import ModalPintor from './ModalPintor';

export default function Vendedores() {
  const [showModal, setShowModal] = useState(false);
  const [showModalInativar, setShowModalInativar] = useState(false);
  const [showModalIsCompany, setShowModalIsCompany] = useState(false);
  const [showModalParcelaPintura, setShowModalParcelaPintura] = useState(false);
  const [cpfPintor, setCpfPintor] = useState('');
  const [nome, setNome] = useState('');
  const [novoEmail, setNovoEmail] = useState('');
  const [atividadePintor, setAtividadePintor] = useState(0);
  const [isCompanyPintor, setIsCompanyPintor] = useState(0);
  const [parcelaPinturaPintor, setParcelaPinturaPintor] = useState(0);
  const [enviando, setEnviando] = useState(false);
  const [showPainterModal, setShowPainterModal] = useState(false);
  const [selectedPainter, setSelectedPainter] = useState({});
  const [justificativa, setJustificativa] = useState('');
  const [showHistoricoModal, setShowHistoricoModal] = useState(false);
  const [historicoAtual, setHistoricoAtual] = useState([]);
  const [carregandoHistorico, setCarregandoHistorico] = useState(false);

  const onHidePainterModal = (toUpdate) => {
    if (toUpdate) {
      window.location.reload();
    }

    setShowPainterModal(false);
  };

  const atualizarSenha = async (e) => {
    e.preventDefault();

    if (!novoEmail) {
      toast.error('Informe o novo e-mail primeiro', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    setEnviando(true);
    try {
      const response = await api.put('/api/parceiros/atualizar-email', {
        cpf: cpfPintor,
        email: novoEmail,
      });

      if (!response) return setEnviando(false);

      toast.success('E-mail atualizado com sucesso!', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      setEnviando(false);
      setShowModal(false);
    } catch (error) {
      toast.error(error.message, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const mudarAtividadePintor = async (e) => {
    e.preventDefault();

    if (!cpfPintor) {
      toast.error('CPF não encontrado.', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (!justificativa.trim()) {
      toast.error('Por favor, informe uma justificativa.', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    setEnviando(true);
    const response = await api
      .put('api/parceiros/atualizar-atividade', {
        cpf: cpfPintor,
        atividade: atividadePintor,
        justificativa: justificativa
      })
      .catch((error) => {
        setEnviando(false);
        toast.error(error.message, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      });

    if (!response) return setEnviando(false);

    toast.success('Atividade atualizada com sucesso!', {
      position: toast.POSITION.BOTTOM_CENTER,
    });
    setEnviando(false);
    setShowModalInativar(false);
    setJustificativa('');
    window.location.reload();
  };

  const mudarIsCompanyPintor = async (e) => {
    e.preventDefault();

    if (!cpfPintor) {
      toast.error('CPF não encontrado.', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (!justificativa.trim()) {
      toast.error('Por favor, informe uma justificativa.', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    setEnviando(true);
    const response = await api
      .put('api/parceiros/atualizar-iscompany', {
        cpf: cpfPintor,
        justificativa: justificativa
      })
      .catch((error) => {
        setEnviando(false);
        toast.error(error.message, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      });

    if (!response) return setEnviando(false);

    toast.success('Tipo de conta atualizada com sucesso!', {
      position: toast.POSITION.BOTTOM_CENTER,
    });
    setEnviando(false);
    setShowModalIsCompany(false);
    setJustificativa('');
    window.location.reload();
  };

  const mudarParcelaPintura = async (e) => {
    e.preventDefault();

    if (!cpfPintor) {
      toast.error('CPF não encontrado.', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (!justificativa.trim()) {
      toast.error('Por favor, informe uma justificativa.', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    setEnviando(true);
    const response = await api
      .put('api/parceiros/atualizar-parcela-pintura', {
        cpf: cpfPintor,
        justificativa: justificativa
      })
      .catch((error) => {
        setEnviando(false);
        toast.error(error.message, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      });

    if (!response) return setEnviando(false);

    toast.success('Parcela Pintura atualizada com sucesso!', {
      position: toast.POSITION.BOTTOM_CENTER,
    });
    setEnviando(false);
    setShowModalParcelaPintura(false);
    setJustificativa('');
    window.location.reload();
  };

  const buscarHistorico = async (cpf) => {
    setCarregandoHistorico(true);
    try {
      const response = await api.get(`/api/parceiros/${cpf}/historico-ativacao`);

      if (response.data) {
        setHistoricoAtual(response.data);
        setShowHistoricoModal(true);
      } else {
        setHistoricoAtual([]);
      }
    } catch (error) {
      toast.error(
        error.response?.data?.erro || 'Erro ao buscar histórico. Tente novamente.',
        {
          position: toast.POSITION.BOTTOM_CENTER,
        }
      );
      setHistoricoAtual([]);
    } finally {
      setCarregandoHistorico(false);
    }
  };

  const columns = [
    {
      dataField: 'id',
      text: 'id',
      hidden: true,
    },
    {
      dataField: 'nome',
      text: 'Pintor',
      sort: true,
      style: { textAlign: 'left' },
      headerStyle: { textAlign: 'left' },
      formatter: (celula, valor) => {
        return (
          <button
            className="btn-limpo"
            onClick={(e) => {
              e.preventDefault();
              historico.push(`pintor/${valor.cpf}`);
            }}
          >
            <b>{capitalize(valor.nome)}</b>
          </button>
        );
      },
    },
    {
      dataField: 'endCidade',
      style: { textAlign: 'left' },
      headerStyle: { textAlign: 'left' },
      text: 'Cidade / UF',
      sort: true,
      formatter: (celula, valor) => {
        return valor.endCidade && valor.endEstado ? `${valor.endCidade} / ${valor.endEstado}` : '';
      },
    },
    {
      text: 'Loja Favorita',
      style: { textAlign: 'left' },
      headerStyle: { textAlign: 'left' },
      dataField: 'lojaPreferida',
      formatter: (celula, valor) => {
        const str = `${
          valor.lojaPreferida ? capitalize(valor.lojaPreferida) : ''
        }, ${
          valor.cidadeLojaPreferida ? capitalize(valor.cidadeLojaPreferida) : ''
        } / ${
          valor.estadoLojaPreferida ? capitalize(valor.estadoLojaPreferida) : ''
        }`;
        return capitalize(valor.lojaPreferida) && str.match(/(.*[a-z]){1}/i)
          ? str
          : '';
      },
      sort: true,
    },
    {
      text: 'Indicação',
      style: { textAlign: 'left' },
      headerStyle: { textAlign: 'left' },
      dataField: 'indicacaoLoja',
      formatter: (celula, valor) => {
        return valor.indicacaoLoja ? capitalize(valor.indicacaoLoja) : '';
      },
      sort: true,
    },
    {
      text: 'Cluster',
      style: { textAlign: 'left' },
      headerStyle: { textAlign: 'left' },
      dataField: 'clusterNome',
      formatter: (celula, valor) => {
        return valor.clusterNome || '-';
      },
      sort: true,
    },    
    {
      dataField: 'cpf',
      text: 'CPF',
      formatter: (celula, valor) => {
        let cpf = valor.cpf.replace(/[^\d]/g, '');
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      },
    },
    {
      dataField: 'celular',
      text: 'Celular',
      formatter: (celula, valor) => {
        return `(${valor.celular.substring(0, 2)}) ${valor.celular.substring(
          2,
          7
        )}-${valor.celular.substring(7)}`;
      },
    },
    {
      dataField: 'totalPontos',
      text: 'Pontuação Total',
      formatter: (celula, valor) => {
        return Number(valor.totalPontos).toLocaleString('pt-BR');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'saldoPontos',
      text: 'Saldo de Pontos',
      formatter: (celula, valor) => {
        return Number(valor.saldoPontos).toLocaleString('pt-BR');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      text: 'Última Pontuação',
      dataField: 'ultimaPontuacao',
      formatter: (celula, valor) => {
        return valor.ultimaPontuacao && valor.ultimaPontuacao !== 0
          ? moment(valor.ultimaPontuacao).format('DD/MM/YYYY HH:mm:ss')
          : '';
      },
      sort: true,
    },
    {
      text: 'Dias do Último Login',
      dataField: 'diasSemAcessar',
      formatter: (celula, valor) => {
        return valor.diasSemAcessar
          ? Number(valor.diasSemAcessar).toLocaleString('pt-BR')
          : '';
      },
      sort: true,
    },
    {
      text: 'Dias sem Pontuar',
      dataField: 'diasSemPontuar',
      formatter: (celula, valor) => {
        return valor.diasSemPontuar
          ? Number(valor.diasSemPontuar).toLocaleString('pt-BR')
          : '';
      },
      sort: true,
    },
    {
      text: 'Aceitou Regulamento',
      dataField: 'aceitouRegulamento',
      formatter: (celula, valor) => {
        return valor.aceitouRegulamento ? 'Sim' : 'Não';
      },
      sort: true,
    },
    {
      text: 'Data de Cadastro',
      dataField: 'criadoEm',
      formatter: (celula, valor) => {
        return moment(valor.criadoEm).format('DD/MM/YYYY');
      },
      sort: true,
    },
    {
      text: 'Alterar E-mail',
      dataField: 'aceitouRegulamento',
      formatter: (celula, valor) => {
        return (
          <button
            className="bg-transparent border-0"
            type="button"
            onClick={() => {
              setCpfPintor(valor.cpf);
              setNome(valor.nome);
              setShowModal(true);
            }}
          >
            <FontAwesomeIcon icon={faEdit} />
          </button>
        );
      },
      sort: true,
    },
    {
      text: 'Editar Pintor',
      dataField: 'editPainter',
      formatter: (celula, valor) => {
        return (
          <button
            className="bg-transparent border-0"
            type="button"
            onClick={() => {
              setSelectedPainter(valor);
              setShowPainterModal(true);
            }}
          >
            <FontAwesomeIcon icon={faEdit} />
          </button>
        );
      },
    },
    {
      text: 'Alterar Status',
      dataField: 'ativo',
      formatter: (celula, valor) => {
        return (
          <button
            className="bg-transparent border-0"
            type="button"
            onClick={() => {
              setCpfPintor(valor.cpf);
              setNome(valor.nome);
              setAtividadePintor(valor.ativo);
              setShowModalInativar(true);
            }}
          >
            <label className="switch">
              {valor.ativo === 1 ? (
                <input type="checkbox" checked disabled />
              ) : (
                <input type="checkbox" disabled />
              )}
              <span className="slider round"></span>
            </label>
          </button>
        );
      },
      sort: false,
    },
    {
      text: 'Pintor Empresa',
      dataField: 'isCompany',
      formatter: (celula, valor) => {
        return (
          <button
            className="bg-transparent border-0"
            type="button"
            onClick={() => {
              setCpfPintor(valor.cpf);
              setNome(valor.nome);
              setIsCompanyPintor(valor.isCompany);
              setShowModalIsCompany(true);
            }}
          >
            <label className="switch">
              {valor.isCompany === 1 ? (
                <input type="checkbox" checked disabled />
              ) : (
                <input type="checkbox" disabled />
              )}
              <span className="slider round"></span>
            </label>
          </button>
        );
      },
      sort: false,
    },
    {
      text: 'Parcela Pintura',
      dataField: 'parcelaPintura',
      formatter: (celula, valor) => {
        return (
          <button
            className="bg-transparent border-0"
            type="button"
            onClick={() => {
              setCpfPintor(valor.cpf);
              setNome(valor.nome);
              setParcelaPinturaPintor(valor.parcelaPintura);
              setShowModalParcelaPintura(true);
            }}
          >
            <label className="switch">
              {valor.parcelaPintura === 1 ? (
                <input type="checkbox" checked disabled />
              ) : (
                <input type="checkbox" disabled />
              )}
              <span className="slider round"></span>
            </label>
          </button>
        );
      },
      sort: false,
    },
    {
      text: 'Status',
      dataField: 'ativo',
      formatter: (celula, valor) => {
        return valor.ativo === 1 ? 'Ativo' : 'Inativo';
      },
      sort: true,
    },
    {
      text: 'Histórico',
      dataField: 'historicoAtivacao',
      formatter: (celula, valor) => {
        return (
          <button
            className="bg-transparent border-0"
            type="button"
            onClick={() => {
              buscarHistorico(valor.cpf);
            }}
          >
            <FontAwesomeIcon icon={faHistory} />
          </button>
        );
      },
      sort: false,
    },
  ];

  return (
    <Container fluid>
      <h4 className="pt-3 pb-3 f-black">Pintores</h4>
      <hr className="hr-loja mt-0 mb-4" />
      <div>
        <RemoteTable
          exportar={{
            fileName: 'pintores',
          }}
          dataId="cpf"
          url="/api/parceiros/painel"
          colunas={columns}
          ordenacaoInicial={{ campo: 'saldoPontos', direcao: 'desc' }}
        />
      </div>
      {showModal && (
        <div id="modal">
          <div className="conteudoModal">
            <form onSubmit={atualizarSenha}>
              <label htmlFor="email">
                Insira o novo e-mail de: <br />
                <span>{nome}</span>
              </label>
              <input
                type="text"
                name="email"
                id="email"
                value={novoEmail}
                onChange={(e) => setNovoEmail(e.target.value)}
              />
              <div className="botoes">
                {!enviando ? (
                  <button type="submit">Alterar</button>
                ) : (
                  <button type="button" disabled>
                    Enviando...
                  </button>
                )}
                <button type="button" onClick={() => setShowModal(false)}>
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showModalInativar && (
        <div id="modal">
          <div className="conteudoModal">
            <form onSubmit={mudarAtividadePintor}>
              {atividadePintor === 1 ? (
                <span className="textoInativar">
                  Tem certeza que deseja inativar o usuário?
                  <br />
                  <span>{nome}</span>
                </span>
              ) : (
                <span className="textoInativar">
                  Tem certeza que deseja ativar o usuário?
                  <br />
                  <span>{nome}</span>
                </span>
              )}
              <textarea
                value={justificativa}
                onChange={(e) => setJustificativa(e.target.value)}
                required
                rows="3"
                placeholder="Informe o motivo desta alteração..."
              />
              <div className="botoes">
                {!enviando ? (
                  <button type="submit">
                    {atividadePintor === 1 ? 'Inativar' : 'Ativar'}
                  </button>
                ) : (
                  <button type="button" disabled>
                    Enviando...
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => {
                    setShowModalInativar(false);
                    setJustificativa('');
                  }}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showHistoricoModal && (
        <div id="modal">
          <div className="conteudoModal historico-modal">
            <h5>Histórico de Alterações</h5>
            {carregandoHistorico ? (
              <p>Carregando...</p>
            ) : historicoAtual && historicoAtual.length > 0 ? (
              <div className="historico-lista">
                {historicoAtual.map((hist, index) => (
                  <div key={index} className="historico-item mb-3">
                    <p><strong>Data:</strong> {moment(hist.criadoEm).format('DD/MM/YYYY HH:mm:ss')}</p>
                    <p><strong>Ação:</strong> {hist.acao}</p>
                    <p><strong>Justificativa:</strong> {hist.justificativa}</p>
                    <p><strong>Usuário:</strong> {hist.usuario?.nome || 'N/A'}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p>Nenhum histórico encontrado.</p>
            )}
            <form>
              <div className="botoes">
                <button type="button" onClick={() => setShowHistoricoModal(false)}>
                  Fechar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showModalIsCompany && (
        <div id="modal">
          <div className="conteudoModal">
            <form onSubmit={mudarIsCompanyPintor}>
              {isCompanyPintor === 1 ? (
                <span className="textoInativar">
                  Tem certeza que deseja alterar para conta individual?
                  <br />
                  <span>{nome}</span>
                </span>
              ) : (
                <span className="textoInativar">
                  Tem certeza que deseja alterar para conta empresa?
                  <br />
                  <span>{nome}</span>
                </span>
              )}
              <textarea
                value={justificativa}
                onChange={(e) => setJustificativa(e.target.value)}
                required
                rows="3"
                placeholder="Informe o motivo desta alteração..."
              />
              <div className="botoes">
                {!enviando ? (
                  <button type="submit">
                    Confirmar
                  </button>
                ) : (
                  <button type="button" disabled>
                    Enviando...
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => {
                    setShowModalIsCompany(false);
                    setJustificativa('');
                  }}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showModalParcelaPintura && (
        <div id="modal">
          <div className="conteudoModal">
            <form onSubmit={mudarParcelaPintura}>
              {parcelaPinturaPintor === 1 ? (
                <span className="textoInativar">
                  Tem certeza que deseja desativar o Parcela Pintura?
                  <br />
                  <span>{nome}</span>
                </span>
              ) : (
                <span className="textoInativar">
                  Tem certeza que deseja ativar o Parcela Pintura?
                  <br />
                  <span>{nome}</span>
                </span>
              )}
              <textarea
                value={justificativa}
                onChange={(e) => setJustificativa(e.target.value)}
                required
                rows="3"
                placeholder="Informe o motivo desta alteração..."
              />
              <div className="botoes">
                {!enviando ? (
                  <button type="submit">
                    Confirmar
                  </button>
                ) : (
                  <button type="button" disabled>
                    Enviando...
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => {
                    setShowModalParcelaPintura(false);
                    setJustificativa('');
                  }}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <ModalPintor
        open={showPainterModal}
        onHide={onHidePainterModal}
        painter={selectedPainter}
      />
    </Container>
  );
}
